export const addresses = {
  dotNounsArt: "0x4b5794e4Fd9B927EE76d74B2411fCA9ACedF0375",
};
